<label [class]="wrapperClass()">
  <input
    type="checkbox"
    role="switch"
    class="bz-switch__input"
    [checked]="checked()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel() || null"
    (change)="toggle()"
    (blur)="markTouched()"
  />
  <span class="bz-switch__track"><span class="bz-switch__thumb"></span></span>
  <span class="bz-switch__label"><ng-content /></span>
</label>
